import {
  type ProviderCancellation,
  providerCancellationText,
} from "@/lib/provider-cancellation";

export function ProviderCancellations({
  operations,
}: {
  operations?: ProviderCancellation[];
}) {
  if (!operations?.length) return null;
  return (
    <section
      className="space-y-1 rounded-md border p-3 text-sm"
      aria-label="Provider cancellation status"
    >
      {operations.map((operation) => (
        <p key={operation.operationId}>
          {providerCancellationText[operation.state]}
        </p>
      ))}
      <p className="text-xs text-muted-foreground">
        {operations.every((operation) => operation.state === "CONFIRMED")
          ? "Provider labels are voided. Cancellation review and customer refund settlement remain separate."
          : "EZX must resolve provider cancellation before retrying approval. A work hold does not confirm the external label is unusable. Customer refunds are handled separately."}
      </p>
    </section>
  );
}
